/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable global-require */
/** **************************************************
class ExampleModal extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      date: '12/25/2018'
    };

    this.onDayChange = this.onDayChange.bind(this);
  }

  onDayChange (day, dayString) {
    this.setState({ date: dayString })
  }

  render() {
    return (
       <SelectTimeWrapper dateFormat='MM/DD/YY'
                        value={ this.state.date }
                        timeFormat={ false }
                        onChange={ this.onDayChange }
                        isValidDate={ (currentDate) => currentDate.isAfter(yesterday); }
       />
    );
  }
}
**************************************************** */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Select from 'react-select';
import { find, get, isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { ACTIVE_LANGUAGE_CODE, DE } from '../../constants';

if (ACTIVE_LANGUAGE_CODE === DE) {
  require('moment/locale/de');
}

class SelectEventTimeWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.availableTimes = this.availableTimes.bind(this);
    this.timeOptions = this.timeOptions.bind(this);
    this.isDisabled = this.isDisabled.bind(this);
    this.scrollHandler = this.scrollHandler.bind(this);

    this.state = {
      times: this.availableTimes(props),
      isMenuOpen: false,
    };
  }

  componentDidMount() {
    this.setState({ times: this.availableTimes(this.props) });
    window.addEventListener('scroll', this.scrollHandler, true);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollHandler, true);
  }

  componentWillReceiveProps(nextProps) {
    const { date, minTime } = nextProps;

    if (this.props.date !== date || (this.props.minTime !== minTime)) {
      this.setState({
        times: this.availableTimes(nextProps),
      });
    }
  }

  scrollHandler(e) {
    if (e?.target?.closest('.select__menu')) {
      return;
    }
    this.setState({ isMenuOpen: false });
  }

  isDisabled(time) {
    return false;
  }


  availableTimes(props) {
    const selectedDate = props.date;
    const times = [];
    const hours = [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22];
    const quarterHours = [0, 15, 30, 45];

    if (moment(new Date()).isSame(selectedDate, 'day')) {
      const minTime = moment(props.minTime, 'h:mm A');
      const maxTime = moment(props.maxTime, 'h:mm A');
      hours.forEach((hour) => {
        quarterHours.forEach((minutes) => {
          const time = moment(`${hour}:${minutes}`, 'HH:mm');

          if (time.isValid() && time.isSameOrAfter(minTime) && time.isSameOrBefore(maxTime)) {
            if (hour === 22 && minutes > 0) { return; }
            times.push(time.format('h:mm A'));
          }
        });
      });

      return times;
    }

    hours.forEach((hour) => {
      quarterHours.forEach((minutes) => {
        const time = moment(`${hour}:${minutes}`, 'HH:mm');

        if (time.isValid()) {
          if (hour === 22 && minutes > 0) { return; }
          times.push(time.format('h:mm A'));
        }
      });
    });

    return times;
  }

  timeOptions() {
    return this.state.times.map((time) => (<option value={time} key={`time-${time}`}>{time}</option>));
  }

  render() {
    const timeValue = this.props.time;
    const updatedList = this.state.times.map((time) => ({
      value: time,
      label: time,
      isDisabled: this.isDisabled(time),
    }));
    return (
      <Select
        className={this.props.customClassName ? this.props.customClassName : "basic-single"}
        classNamePrefix="select"
        value={this.isDisabled(timeValue)
          ? find(updatedList, (elt) => (elt && !elt.isDisabled))
          || {} : { value: timeValue, label: timeValue }}
        options={updatedList}
        isSearchable={false}
        onChange={(val) => this.props.onChange(val.value || '')}
        menuShouldBlockScroll={this.props.dontBlockScroll ? false : true}
        menuIsOpen={this.state.isMenuOpen}
        onMenuClose={() => this.setState({ isMenuOpen: false })}
        onMenuOpen={() => this.setState({ isMenuOpen: true })}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  fieldsHolder: state.fieldsHolder,
});

SelectEventTimeWrapper.propTypes = {
  date: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
  maxTime: PropTypes.string.isRequired,
  minTime: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, {})(SelectEventTimeWrapper);
